import React from 'react';
import './PatientsGrid.css';

const PatientsGrid = ({ 
  patients, 
  onView,
  onRestore,
  formatDate,
  readOnly = false,
}) => {
  return (
    <div className="patients-grid-container">
      <div className="patients-grid">
        {patients.map(patient => (
          <div 
            key={patient.id} 
            className={`patient-card ${readOnly ? 'read-only' : ''}`}
            onClick={() => !readOnly && onView && onView(patient)}
            style={readOnly ? { cursor: 'default' } : {}}
          >
            <div className="patient-card-content">
              <div className="patient-main-info">
                <div className="patient-info">
                  <h3 className="patient-name">
                    {patient.firstName} {patient.lastName}
                    {readOnly && (
                      <span className="deleted-badge-mobile">
                        <i className="fas fa-trash"></i> Archivado
                      </span>
                    )}
                  </h3>
                  {patient.dateOfBirth && (
                    <div className="patient-contact">
                      <span className="patient-email">
                        <i className="fas fa-calendar"></i>
                        {formatDate(patient.dateOfBirth)}
                      </span>
                    </div>
                  )}
                </div>
                {!readOnly && (
                  <div className="action-indicator">
                    <i className="fas fa-chevron-right"></i>
                  </div>
                )}
              </div>

              {readOnly && onRestore && (
                <div className="patient-card-actions">
                  <button 
                    className="restore-button-mobile"
                    onClick={(e) => {
                      e.stopPropagation();
                      onRestore(patient);
                    }}
                  >
                    <i className="fas fa-undo"></i>
                    Restaurar
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PatientsGrid; 